import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Check from "@material-ui/icons/Check";
import StepConnector from "@material-ui/core/StepConnector";
import Button from "@material-ui/core/Button";
import { CircularProgress, Container, Grid } from "@material-ui/core";
import TopBar from "../../../layouts/DashboardLayout/TopBar";
import * as YUP from "yup";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  SaveWorkerRegisterForm,
  UpdateWorkerRegisterForm,
} from "../../../redux/actions/worker";
import { useTranslation } from "react-i18next";
import PersonIcon from "@material-ui/icons/Person";
import SchoolIcon from "@material-ui/icons/School";
import WorkIcon from "@material-ui/icons/Work";
import PrintIcon from "@material-ui/icons/Print";
import BallotIcon from "@material-ui/icons/Ballot";

import Personal from "./Personal";
import VocationalTraining from "./VocationalTraining";
import Experience from "./Experience";
import Documents from "./Documents";
import Tags from "./Tags";
import store from "src/redux/store";
import Information from "src/components/Information";
import { ManagementService, WorkerService } from "src/services";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: "#784af4",
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
  completed: {
    color: "#784af4",
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
};

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  completed: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <PersonIcon />,
    2: <SchoolIcon />,
    3: <WorkIcon />,
    4: <PrintIcon />,
    5: <BallotIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
  },
}));



function getSteps(t,role,location) {
  let isProfile = location?.pathname.includes("/app/worker_profile/")? true:false; 
  if (role === "Admin" ||isProfile ) {
    return [
      t("pages.workerregister.personal.stepname"),
      t("pages.workerregister.vocationalTraining.stepname"),
      t("pages.workerregister.experience.stepname"),
      t("pages.workerregister.documents.stepname"),
      t("pages.workerregister.vocationaltag.stepname"),
    ];
  } else {
    return [
      t("pages.workerregister.personal.stepname"),
      t("pages.workerregister.vocationalTraining.stepname"),
      t("pages.workerregister.experience.stepname"),
    ];
  }
}

function getStepContent(
  step,
  touched,
  errors,
  values,
  handleBlur,
  handleChange,
  setFieldValue,
  genderList,
  nationalityList,
  maritalStatusList,
  countryList,
  cityList,
  getResult,
  vocationalTrainingType,
  registeredBefore,
  disableDiv
) {
  switch (step) {
    case 0:
      return (
        <Personal
          touched={touched}
          errors={errors}
          values={values}
          handleBlur={handleBlur}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
          genderList={genderList}
          nationalityList={nationalityList}
          maritalStatusList={maritalStatusList}
          countryList={countryList}
          cityList={cityList}
          getResult={getResult}
        />
      );
    case 1:
      return (
        <VocationalTraining
          touched={touched}
          errors={errors}
          values={values}
          handleBlur={handleBlur}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
          vocationalTrainingType={vocationalTrainingType}
        />
      );
    case 2:
      return (
        <Experience
          touched={touched}
          errors={errors}
          values={values}
          handleBlur={handleBlur}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
        />
      );
    case 3:
      return (
        <Documents
          touched={touched}
          errors={errors}
          values={values}
          handleBlur={handleBlur}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
          disabled={disableDiv}
        />
      );
    case 4:
      return (
        <Tags
          touched={touched}
          errors={errors}
          values={values}
          handleBlur={handleBlur}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
          registeredBefore={registeredBefore}
          disabled={disableDiv}
        />
      );

    default:
      return "Unknown step";
  }
}

const initialValues = {
  baseFields: {
    firstName: undefined,
    middleName: undefined,
    lastName: undefined,
    initials: undefined,
    address: {
      label: undefined,
      detail: undefined,
      postCode: undefined,
      city: undefined,
      countryCode: undefined,
      isPrimary: true,
    },
    privatePhoneNumber: undefined,
    mobilePhoneNumber: undefined,
    emergencyPhoneNumber: undefined,
    emergencyPhoneNumberOwner: undefined,
    emergencyPhoneNumberOwnerRelationship: undefined,
    emailAddress: undefined,
    nationalityCode: undefined,
    birthPlace: undefined,
    birthDate: undefined,
    genderCode: undefined,
    maritalStatusCode: undefined,
    resumePath: undefined,
    passportNumber: undefined,
    passportImagePath: undefined,
    passportValidityDate: undefined,
    identityCardNumber: undefined,
    identityCardImagePath: undefined,
    identityCardValidityDate: undefined,
    hasAnyCar: false,
    driversLicenceNumber: undefined,
    driversLicenceValidityDate: undefined,
    residencePermit: undefined,
    residencePermitValidityDate: undefined,
    citizenServiceNumber: undefined,
    hasAnyHealthInsurance: false,
    healthInsuranceDetail: undefined,
    bankOfPayment: undefined,
    bankAccountNumberOfPayment: undefined,
    iban: undefined,
    hasDiplomaBasicSafetyVca: false,
    diplomaBasicSafetyVcanumber: undefined,
    hasSafetyPassport: false,
    safetyPassportNumber: undefined,
    isRegistered: false,
    isRegisteredAlready: false,
    isForeignWorker: false,
  },
  vocationalTrainingList: [],
  workExperienceList: [],
  vocationalTagList: [],
};
const validationSchema = [
  YUP.object({
    baseFields: YUP.object({
      firstName: YUP.string().required("First Name is Required"),
      lastName: YUP.string().required("Last Name is Required"),
      emailAddress: YUP.string().email().required("Email is Required"),
      birthDate: YUP.string().required("Birth Date is Required"),
      privatePhoneNumber: YUP.string().required("Phone Number is Required"),
      address: YUP.object({
        detail: YUP.string().required("Address is Required"),
        postCode: YUP.string().required("Zip Code is Required"),
        //country: YUP.string().nullable().required("Country is Required"),
        city: YUP.string().required("City is Required"),
      }),
    }),
  }),
  YUP.object().shape({}),
  YUP.object().shape({}),
  YUP.object().shape({}),
  YUP.object().shape({}),
  YUP.object().shape({}),
  YUP.object().shape({}),
];
const WorkerRegister = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {role } = useSelector((state) => state.authReducer);  
  const formikRef = useRef();
  const { t } = useTranslation();
  const steps = getSteps(t,role,location);
  const [activeStep, setActiveStep] = React.useState(0);
  const currentValidationSchema = validationSchema[activeStep];

  const [genderList, setGenderList] = useState([]);
  const [nationalityList, setNationalityList] = useState([]);
  const [maritalStatusList, setMaritalStatusList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [vocationalTrainingType, setVocationalTrainingType] = useState([]);
  const [registeredBefore, setRegisteredBefore] = useState(false);
  const [disableDiv, setDisableDiv] = useState(false);
  const [processStatus, setProcessStatus] = useState(false)
  const { id } = useParams();
  const isAddMode = !id;
   
  const state = useSelector((state) => state.workerReducer);
  const { success, error } = state;
  
  if (success && processStatus) {
    setProcessStatus(false);
    if (disableDiv) {
      navigate("/app/", { replace: true });
    } else {
      if (role === "Admin") {
        navigate("/app/worker_management", { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    }
  }

  const handleNext = () => {
    if (activeStep !== steps.length - 1) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    if (activeStep === steps.length - 1) {
      if (isAddMode) {
        await createWorker(values, setSubmitting);
      } else {
        await updateWorker(id, values, setSubmitting);
      }
    } else {
      setSubmitting(false);
      handleNext();
    }
  };

  async function createWorker(values, setSubmitting) {
    dispatch(SaveWorkerRegisterForm(values, setSubmitting,setProcessStatus));
    await new Promise((resolve) => setTimeout(resolve, 2000));
  }

  async function updateWorker(id, values, setSubmitting) {
    dispatch(
      UpdateWorkerRegisterForm(id, registeredBefore, values, setSubmitting,setProcessStatus)
    );
    await new Promise((resolve) => setTimeout(resolve, 2000));
  }

  const getWorkerById = async (id) => {
    try {
      const response = await WorkerService.GET_WORKER_EXTRA_BY_ID(id);
      const { success, message, data } = await response.data;
      if (success) {
        await getResult(data.baseFields.address.countryCode + "Cities");
        //await new Promise((resolve) => setTimeout(resolve, 2000));
        if (formikRef.current) {
          let arr = [];
          data.vocationalTagList.map((tag) =>
            arr.push({ value: tag.id, label: tag.stringValue })
          );
          let dat = { ...data, vocationalTagList: arr };
          await formikRef.current.setValues(dat);
          if (data.baseFields.isRegistered === true) {
            setRegisteredBefore(true);
          }
        }
      } else {
        console.log("Error (GET_WORKER_EXTRA_BY_ID) :  ", message);
      }
    } catch (error) {
      console.log("Error (GET_WORKER_EXTRA_BY_ID) :  ", error);
    }
  };

  const getResult = async (metadataGroup) => {
    // await new Promise(resolve => setTimeout(resolve, 1000));
    var parameterdata = [{ metadataCode: "", metadataValue: "Select" }];
    const result = await ManagementService.GET_METEDATA_VALUES(metadataGroup);
    if (result.status === 200) {
      const { data } = await result.data;
      data.forEach((rc) => {
        parameterdata.push({
          metadataCode: rc.metadataCode,
          metadataValue: rc.metadataValue,
        });
      }); 
      if (metadataGroup === "Gender") {
        setGenderList(parameterdata);
      } else if (metadataGroup === "Nationality") {
        setNationalityList(parameterdata);
      } else if (metadataGroup === "MaritalStatus") {
        setMaritalStatusList(parameterdata);
      } else if (metadataGroup === "Country") {
        setCountryList(parameterdata);
      } else if (metadataGroup === "VocationalTrainingType") {
        setVocationalTrainingType(parameterdata);
      } else {
        setCityList(parameterdata);
      }
    } else {
      console.error("getResult Error = " + result.statusText);
    }
  };

  const getParameters = async () => {
    await getResult("Gender");
    await getResult("Nationality");
    await getResult("MaritalStatus");
    await getResult("Country");
    await getResult("VocationalTrainingType");
  };
  const getWorker = async () => {
    await getWorkerById(id);
  };

  const setDivDisable = async () => {
    if (id) {
      if (location?.pathname.includes("/app/worker_profile/") && role!=="Admin") {
        setDisableDiv(true);
      } else {
        setDisableDiv(false);
      }
    }
  };
  
  const callllAPIS = async () => {
    await setDivDisable();
    await  getParameters();
    if (!isAddMode) {
     await getWorker();
   }
   else{
     formikRef.current.resetForm();
   }
 };
  useEffect(() => {  
    callllAPIS();
    
  }, []);

  return (
    <Container>
      <TopBar />

      <div
        style={{
          position: "fixed",
          top: 60,
          left: "10%",
          width: "80%",
          zIndex: 1,
        }}
      >
        <Stepper
          alternativeLabel
          activeStep={activeStep}
          connector={<ColorlibConnector />}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>

      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={currentValidationSchema}
        onSubmit={onSubmit}
        validateOnBlur
        validateOnMount
      >
        {({
          errors,
          touched,
          values,
          isSubmitting,
          isValid,
          handleBlur,
          handleChange,
          handleSubmit,
          resetForm,
          setFieldValue,
        }) => (
          <>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <div style={{ paddingTop: 150, paddingBottom: 75 }}>
                  <Grid item md={12} xs={12}>
                    {getStepContent(
                      activeStep,
                      touched,
                      errors,
                      values,
                      handleBlur,
                      handleChange,
                      setFieldValue,
                      genderList,
                      nationalityList,
                      maritalStatusList,
                      countryList,
                      cityList,
                      getResult,
                      vocationalTrainingType,
                      registeredBefore,
                      disableDiv
                    )}
                  </Grid>
                </div>
                <div
                  style={{
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    paddingBottom: 20,
                    backgroundColor: "white",
                    zIndex: 1,
                  }}
                >
                  <Grid item md={12} xs={12} align="center">
                    <div className={classes.wrapper}>
                      <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={classes.button}
                      >
                        {t("common.back")}
                      </Button>
                      <Button
                        disabled={
                          activeStep === steps.length - 1 &&
                          (!isValid || isSubmitting)
                        }
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.button}
                      >
                        {activeStep === steps.length - 1
                          ? t("common.finish")
                          : t("common.next")}
                     
                      {activeStep === steps.length - 1 && isSubmitting ? (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      ) : null}
                       </Button>
                    </div>
                  </Grid>
                </div>
              </Grid>
            </form>
            {!isSubmitting ? (
              <Information
                success={success}
                message={success ? "Saved Successfuly" : error}
              />
            ) : null}
          </>
        )}
      </Formik>
    </Container>
  );
};

export default WorkerRegister;
